// extracted by mini-css-extract-plugin
export default {"form":"site-checker_form__vh1gd"};